import * as cms from '../../common/api/cms';

export const FETCH_REGION_BY_SLUG = 'FETCH_REGION_BY_SLUG';
export const FETCH_REGION_BY_SLUG_SUCCESS = 'FETCH_REGION_BY_SLUG_SUCCESS';
export const FETCH_REGION_BY_SLUG_FAILURE = 'FETCH_REGION_BY_SLUG_FAILURE';

export const FETCH_REGION_BY_COORDINATES = 'FETCH_REGION_BY_COORDINATES';
export const FETCH_REGION_BY_COORDINATES_SUCCESS = 'FETCH_REGION_BY_COORDINATES_SUCCESS';
export const FETCH_REGION_BY_COORDINATES_FAILURE = 'FETCH_REGION_BY_COORDINATES_FAILURE';

export const fetchRegionBySlug = (slug, fetch = true) => async (dispatch) => {
  dispatch({ type: FETCH_REGION_BY_SLUG });

  try {
    const region = fetch ? await cms.fetchRegionBySlug(slug) : {};
    dispatch({
      type: FETCH_REGION_BY_SLUG_SUCCESS,
      region: region.slug_match,
    });
  } catch (err) {
    dispatch({
      type: FETCH_REGION_BY_SLUG_FAILURE,
      error: err,
    });
  }
};

export const fetchRegionByCoordinates = (coordinates, fetch = true) => async (dispatch) => {
  dispatch({ type: FETCH_REGION_BY_COORDINATES });

  try {
    const nearbyRegion = fetch ? await cms.fetchNearbyRegionByCoordinates(coordinates) : {};
    const region = fetch ? await cms.fetchRegionBySlug(nearbyRegion.slug) : {};
    dispatch({
      type: FETCH_REGION_BY_COORDINATES_SUCCESS,
      region: region.slug_match,
    });
  } catch (err) {
    dispatch({
      type: FETCH_REGION_BY_COORDINATES_FAILURE,
      error: err,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/cms/region.js